export function isPhoneNumber(input: string): boolean {
    if (!input) return false;

    return /^[+\d]?[\d-.\s()]*$/.test(input);
}

export function isFullName(input: string): boolean {
    if (!input) return false;

    return input.trim().indexOf(' ') > -1;
}

export function isEmail(input: string): boolean {
    if (!input) return false;

    // common typos
    if (input.endsWith('@gmail.co')) return false;
    if (input.endsWith('@hotmail.co')) return false;
    if (input.endsWith('@outlook.co')) return false;

    // tld check
    if (!/@.+?\..+?$/.test(input)) return false;

    // the same regex as used in knockout validation
    return /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test(
        input,
    );
}

// This checks if the input looks like a CPR number.
// It does not use the modulus validation, since not all CPR numbers use this anymore.
export function isCprNumber(input: string): boolean {
    if (!input) return false;

    if (!/^[0-9]{10}$/.test(input)) return false;

    const day = parseInt(input.substring(0, 2));
    const month = parseInt(input.substring(2, 4));
    const year = parseInt(input.substring(4, 6));
    const seventhDigit = parseInt(input.substring(6, 7));
    const century = getCprCentury(year, seventhDigit);
    const fullYear = century + year;

    const isValidMonth = 0 < month && month <= 12;

    // This gets us the number of days in the relevant month because:
    // - months are 0-based, so passing "month" will give us next month
    // passing day 0 will give us last day of previous month (the relevant month)
    const daysInMonth = new Date(fullYear, month, 0).getDate();
    const isValidDay = 0 < day && day <= daysInMonth;

    return isValidMonth && isValidDay;
}

export const isUnderCertainAge = (cpr: string, validate: number): boolean => {
    if (!cpr) return true;

    const cleanedCPR = cpr.replace(/[-\s]/gi, '');
    if (cleanedCPR.length < 7) return true;

    const birthday = cprToDateOfBirth(cleanedCPR);
    const maxAgeYearsAgo = new Date();
    maxAgeYearsAgo.setFullYear(maxAgeYearsAgo.getFullYear() - validate);
    return birthday > maxAgeYearsAgo;
};

export const cprToDateOfBirth = (cpr: string): Date => {
    const day = parseInt(cpr.substring(0, 2));
    const month = parseInt(cpr.substring(2, 4));
    const year = parseInt(cpr.substring(4, 6));
    const seventhDigit = parseInt(cpr.substring(6, 7));
    const century = getCprCentury(year, seventhDigit);

    // months are zero indexed
    return new Date(century + year, month - 1, day);
};

const getCprCentury = (year: number, seventhDigit: number): number => {
    switch (seventhDigit) {
        case 0:
        case 1:
        case 2:
        case 3:
            return 1900;
        case 4:
        case 9:
            if (year <= 36) {
                return 2000;
            } else {
                return 1900;
            }
        case 5:
        case 6:
        case 7:
        case 8:
            if (year <= 57) {
                return 2000;
            } else {
                return 1800;
            }
    }
};
